export type Language = "en" | "th";

export const copy = {
  en: {
    kicker: "Guest listening room",
    heroLine: "Pick a song.",
    heroAccent: "Keep the flow.",
    tagline: "Your pick joins the line. Nothing playing gets interrupted.",
    online: "Player online",
    offline: "Jukebox is offline",
    roomClosed: "Room is closed",
    requestsPaused: "Requests paused",
    nowPlaying: "Now playing",
    waitingForPlayer: "Waiting for the player",
    queueTitle: "Coming up",
    songSingular: "song",
    songPlural: "songs",
    queueEmpty: "The guest queue is clear",
    queueEmptyHint: "YouTube will choose the next recommendation unless someone adds a song.",
    nextRequest: "Next request",
    playNextTitle: "Want to play this now?",
    skipPromptTitle: "Play this next?",
    skipPromptHint: "This will skip the current song and start the next request.",
    playNow: "Play now",
    skipping: "Skipping…",
    keepPlaying: "Keep current song",
    skipRequested: "Starting the next requested song",
    skipUnavailable: "This song can no longer be skipped by guests.",
    joinTitle: "What should we call you?",
    joinHint: "This name is temporary and only appears beside your requests.",
    namePlaceholder: "Your name",
    join: "Join the room",
    searchTitle: "Add your song",
    searchHint: "Search in Thai or English, or paste a YouTube link.",
    musicOnlyHint: "Music only: add videos categorized as Music by YouTube.",
    searchPlaceholder: "Song, artist, or YouTube link",
    search: "Search",
    searching: "Searching…",
    addVideo: "Add video",
    checkingAndAdding: "Checking and adding…",
    resultTitle: "Choose a result",
    add: "Add to end of queue",
    adding: "Adding…",
    added: "Added to the end of the queue",
    removeRequest: "Remove your request",
    removed: "Removed from the queue",
    removeUnavailable: "This request is no longer waiting in the queue.",
    position: "Approximate position",
    requestedBy: "Requested by",
    you: "You",
    minutes: "min",
    leave: "Change name",
    retry: "Try again",
    loading: "Loading Keep the Remote",
    dismiss: "Dismiss",
    invalidRoom: "This room link is incomplete.",
    unavailable: "This room is unavailable.",
    noResults: "No matching videos found. Try a different phrase or paste a YouTube link.",
    quota: "YouTube search is temporarily unavailable. A pasted YouTube link may still work.",
    cooldown: "Please wait a moment before adding another song.",
    requestLimit: "You have reached this room's queued request limit.",
    duplicate: "That video is already in the queue.",
    queueFull: "The queue is full for now.",
    tooLong: "That video is longer than this room allows.",
    offlineSubmit: "The jukebox is offline. New songs cannot be added yet.",
    liveRejected: "Live streams and upcoming premieres are not accepted here.",
    shortRejected: "YouTube Shorts are not accepted here.",
    musicOnlyRejected: "This room only accepts videos categorized as Music by YouTube.",
    musicCategoryUnavailable:
      "YouTube could not verify this video as music. Please try another video.",
    sessionExpired: "Your guest session expired. Enter your name to rejoin.",
    invalidVideo: "Enter a valid, available YouTube video link.",
    videoUnavailable:
      "YouTube could not verify this video. It may be unavailable or temporarily unsupported.",
    durationUnavailable: "YouTube did not provide this video's duration. Please try again.",
    genericError: "Something went wrong. Please try again.",
    refresh: "Refresh",
    serviceNote: "Songs play in order · Native YouTube recommendations fill quiet moments",
  },
  th: {
    kicker: "ห้องฟังเพลงสำหรับแขก",
    heroLine: "เลือกเพลงที่ชอบ",
    heroAccent: "แล้วปล่อยให้เพลงไหลต่อ",
    tagline: "เพลงที่คุณเลือกจะต่อท้ายคิว โดยไม่ขัดจังหวะเพลงที่กำลังเล่น",
    online: "เครื่องเล่นออนไลน์",
    offline: "ตู้เพลงออฟไลน์",
    roomClosed: "ห้องปิดอยู่",
    requestsPaused: "หยุดรับเพลงชั่วคราว",
    nowPlaying: "กำลังเล่น",
    waitingForPlayer: "กำลังรอเครื่องเล่น",
    queueTitle: "เพลงถัดไป",
    songSingular: "เพลง",
    songPlural: "เพลง",
    queueEmpty: "คิวเพลงจากแขกยังว่าง",
    queueEmptyHint: "YouTube จะเลือกเพลงแนะนำถัดไป จนกว่าจะมีคนเพิ่มเพลง",
    nextRequest: "เพลงถัดไปในคิว",
    playNextTitle: "อยากเปิดเพลงนี้ตอนนี้ไหม?",
    skipPromptTitle: "เปิดเพลงนี้เป็นเพลงถัดไปไหม?",
    skipPromptHint: "ระบบจะข้ามเพลงปัจจุบันและเปิดเพลงถัดไปในคิว",
    playNow: "เปิดตอนนี้",
    skipping: "กำลังข้าม…",
    keepPlaying: "เล่นเพลงปัจจุบันต่อ",
    skipRequested: "กำลังเปิดเพลงที่ขอไว้ถัดไป",
    skipUnavailable: "แขกไม่สามารถข้ามเพลงนี้ได้แล้ว",
    joinTitle: "ให้เราเรียกคุณว่าอะไร?",
    joinHint: "ชื่อนี้ใช้ชั่วคราวและจะแสดงข้างเพลงที่คุณขอเท่านั้น",
    namePlaceholder: "ชื่อของคุณ",
    join: "เข้าร่วมห้อง",
    searchTitle: "เพิ่มเพลงของคุณ",
    searchHint: "ค้นหาเป็นภาษาไทยหรืออังกฤษ หรือวางลิงก์ YouTube",
    musicOnlyHint: "รับเฉพาะเพลง: เพิ่มได้เฉพาะวิดีโอที่ YouTube จัดอยู่ในหมวดหมู่เพลง",
    searchPlaceholder: "ชื่อเพลง ศิลปิน หรือลิงก์ YouTube",
    search: "ค้นหา",
    searching: "กำลังค้นหา…",
    addVideo: "เพิ่มวิดีโอ",
    checkingAndAdding: "กำลังตรวจสอบและเพิ่ม…",
    resultTitle: "เลือกผลการค้นหา",
    add: "เพิ่มไว้ท้ายคิว",
    removeRequest: "นำคำขอของคุณออก",
    removed: "นำเพลงออกจากคิวแล้ว",
    removeUnavailable: "คำขอนี้ไม่ได้รออยู่ในคิวแล้ว",
    adding: "กำลังเพิ่ม…",
    added: "เพิ่มเพลงไว้ท้ายคิวแล้ว",
    position: "ลำดับโดยประมาณ",
    requestedBy: "ขอโดย",
    you: "คุณ",
    minutes: "นาที",
    leave: "เปลี่ยนชื่อ",
    retry: "ลองอีกครั้ง",
    loading: "กำลังเปิด Keep the Remote",
    dismiss: "ปิดข้อความ",
    invalidRoom: "ลิงก์ห้องนี้ไม่สมบูรณ์",
    unavailable: "ไม่สามารถเปิดห้องนี้ได้",
    noResults: "ไม่พบวิดีโอ ลองใช้คำค้นอื่นหรือวางลิงก์ YouTube",
    quota: "การค้นหา YouTube ใช้งานไม่ได้ชั่วคราว แต่คุณยังลองวางลิงก์ YouTube ได้",
    cooldown: "กรุณารอสักครู่ก่อนเพิ่มเพลงถัดไป",
    requestLimit: "คุณส่งคำขอครบจำนวนที่ห้องนี้กำหนดแล้ว",
    duplicate: "วิดีโอนี้อยู่ในคิวแล้ว",
    queueFull: "คิวเต็มแล้วในขณะนี้",
    tooLong: "วิดีโอนี้ยาวเกินกว่าที่ห้องนี้อนุญาต",
    offlineSubmit: "ตู้เพลงออฟไลน์ จึงยังเพิ่มเพลงใหม่ไม่ได้",
    liveRejected: "ห้องนี้ไม่รับไลฟ์สดหรือพรีเมียร์ที่ยังไม่เริ่ม",
    shortRejected: "ห้องนี้ไม่รับ YouTube Shorts",
    musicOnlyRejected: "ห้องนี้รับเฉพาะวิดีโอที่ YouTube จัดอยู่ในหมวดหมู่เพลง",
    musicCategoryUnavailable:
      "YouTube ไม่สามารถยืนยันว่าวิดีโอนี้อยู่ในหมวดหมู่เพลงได้ กรุณาลองวิดีโออื่น",
    sessionExpired: "เซสชันของคุณหมดอายุ กรุณาใส่ชื่อเพื่อเข้าร่วมอีกครั้ง",
    invalidVideo: "กรุณาใส่ลิงก์วิดีโอ YouTube ที่ถูกต้องและเปิดดูได้",
    videoUnavailable:
      "YouTube ไม่สามารถตรวจสอบวิดีโอนี้ได้ วิดีโออาจไม่พร้อมใช้งานหรือระบบอาจไม่รองรับชั่วคราว",
    durationUnavailable: "YouTube ไม่ได้แจ้งความยาวของวิดีโอนี้ กรุณาลองอีกครั้ง",
    genericError: "เกิดข้อผิดพลาด กรุณาลองอีกครั้ง",
    refresh: "รีเฟรช",
    serviceNote: "เล่นเพลงตามลำดับ · ใช้เพลงแนะนำของ YouTube เมื่อคิวว่าง",
  },
} as const;

export type Copy = (typeof copy)[Language];
